import React from 'react'

function DriverInfoOptionsInput({ name, options, value, onChange, className, error, disabled }) {
  return (
    <div className={`drivers-info__options-input ${disabled ? 'disabled' : ''}`}>
      {options.map(option =>
        <div key={option.value} onClick={() => !disabled && onChange(option.value)} className={`drivers-info__options-input-item ${value === option.value ? 'selected' : ''}`}>
          {option.text}
        </div>
      )}
    </div>
  )
}

export default DriverInfoOptionsInput
